import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PartnerService } from '../../services/partner.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-product',
  templateUrl: './subscription-product.component.html',
  styleUrls: ['./subscription-product.component.scss']
})
export class SubscriptionProductComponent implements OnInit {
  productPriceList = [];
  isPageEditable = true;
  subscriptionShow = false;
  productForm: FormGroup;
  IsFormEdit = false;
  statusMessage = '';
  allPartnersList = [];
  partners = [];
  isSlide: any;
  sideBarToggle: any;
  selectedPartnerId = ''; 
  formSubmitAttempt = false;
  showFamilyMember = true;
  partnerTypeList = [
    "Corporate",
    "Subscription"
  ];
  subscriptionProductList = [];
  partnerId: '';
  prductforIndividual = true;
  productforfamily = false;
  subscriptionFor : any = '';
  

  constructor(private fb: FormBuilder,private _partnerService: PartnerService,private router: Router) {
    this.productForm = fb.group({
      productName: [],
      description: [],
      // uniqueCode:[],
      price:[],
      maxusage: [],
      familymembers:[],
      partnerId: []

    });
    this.getPartnerList();
   }

  ngOnInit() {
    
    
  }

  getPartnerList() {
    let tempPartnersList = [];
    this._partnerService.getPartners()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.partners = employeeData.response.partnerList;
            this.allPartnersList = this.partners;
            console.log('this.partners ', this.partners);
            console.log('this.allPartnersList ', this.allPartnersList);
            for(let index = 0; index< this.partners.length;index++){
              if(this.partners[index].partnerType.toLowerCase() == 'Subscription'.toLowerCase()){
                tempPartnersList.push(this.partners[index]);
              }
            }
            this.partners = tempPartnersList;
            this.getSubscriptionProduct();
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }


  selectPartner(data: any){
    if(data != '0'){
      let tempPartnersList = [];
      for(let index = 0;index < this.allPartnersList.length;index++){
        if(this.allPartnersList[index].partnerType.toLowerCase() == data.toLowerCase()){
          tempPartnersList.push(this.allPartnersList[index]);
        }
      }
      this.partners = tempPartnersList;
    }
  }

  selectPartnerId(data: any){
    console.log('data ', data);
    this.selectedPartnerId = data;
  }


  selectPrimary(data){
    if(data == 'family'){
      // this.showFamilyMember = false;
      this.subscriptionFor = 'family';
    }
    else{
      // this.showFamilyMember = true;
      this.subscriptionFor = 'individual';
    }
  }


  
  
  addRecord(record) {
    console.log('record value ', record.value);
    this.formSubmitAttempt = true;
    var date = new Date();
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.productTypeId = (record.value.productTypeId == null || record.value.productTypeId == '') ? 2 : record.value.productTypeId;
    record.value.token = loginUser.token;
    record.value.productTypeId = 8;
    record.value.name = record.value.productName;
    record.value.uniqueCode = '';
    record.value.productfor =  this.subscriptionFor;
    if (record.invalid) {
      return;
    }
    else {
      this._partnerService.saveProduct(record.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            console.log('resturned ', data);
            record.value.productId = parseInt(data.response[0].id);
            record.value.partnerId = parseInt(this.selectedPartnerId);
            record.value.price = parseInt(record.value.price);
            this._partnerService.AddPartnerProduct(record.value).subscribe(
              data => {
                if (data.returnCode == 0) {
                  alert("records save Sucessfully")
                  this.productForm.reset();
                  this.formSubmitAttempt = false;
                  this.getSubscriptionProduct();
    
                }
                else {
                  alert(data.returnMsg)
    
                }
              },
              error => {
                alert(error)
                console.log(error)
              });
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  getSubscriptionProduct(){
    this._partnerService.getSubscriptionPartnerProduct().subscribe(
      data => {
        if (data.returnCode == 0) {
          console.log('data ', data.response);
          this.subscriptionProductList = data.response;
          for(let index = 0;index<this.allPartnersList.length;index++){
            for(let innerindex = 0; innerindex < this.subscriptionProductList.length; innerindex++){
              if(this.allPartnersList[index].partnerId == this.subscriptionProductList[innerindex].partnerid){
                this.subscriptionProductList[innerindex].partnerType = this.allPartnersList[index].partnerType;
                // this.subscriptionProductList[innerindex].partnerName = this.allPartnersList[index].partnerName;
              }
            }
          }
        }
      });
      console.log('find ', this.subscriptionProductList);
  }


  // edit the Subscription product.
  showUpdate(productData: any){
    console.log('productData ', productData);
    this.isPageEditable = false;
    this.IsFormEdit = true;
    this.productForm.controls['productName'].setValue(productData.name);
    this.productForm.controls['description'].setValue(productData.description);
    this.productForm.controls['partnerId'].setValue(productData.partnerid);
    this.productForm.controls['price'].setValue(parseInt(productData.price));
    this.productForm.controls['maxusage'].setValue(productData.maxusage);
    if(productData.productfor == 'family'){
      this.productforfamily = true;
      this.prductforIndividual = false;
    }
    else if(productData.productfor == 'individual'){
      this.productforfamily = false;
      this.prductforIndividual = true;
    }
    
  }

  // update the subscription product.
  EditPartnerProduct(record){
    console.log('record value ', record.value);
    this.formSubmitAttempt = true;
    var date = new Date();
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.productTypeId = (record.value.productTypeId == null || record.value.productTypeId == '') ? 2 : record.value.productTypeId;
    record.value.token = loginUser.token;
    record.value.productTypeId = 8;
    record.value.name = record.value.productName;
    record.value.uniqueCode = '';
    record.value.productfor =  this.subscriptionFor;
    if (record.invalid) {
      return;
    }
    else {
      this._partnerService.updateProduct(record.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            console.log('resturned ', data);
            record.value.productId = parseInt(data.response[0].id);
            record.value.partnerId = parseInt(this.selectedPartnerId);
            record.value.price = parseInt(record.value.price);
            this._partnerService.updatePartnerProduct(record.value).subscribe(
              data => {
                if (data.returnCode == 0) {
                  alert("records updated Sucessfully")
                  this.productForm.reset();
                  this.formSubmitAttempt = false;
                  this.getSubscriptionProduct();
    
                }
                else {
                  alert(data.returnMsg)
    
                }
              },
              error => {
                alert(error)
                console.log(error)
              });
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  // delete partner product.
  deletePartnerProduct(data: any){
    console.log('deletePartnerProduct ', data);
    let productData = {"productId":data.id};
    this._partnerService.deleteProduct(productData).subscribe(
      data => {
        console.log('data ', data);
        if(data.returnCode == 0){
          alert('Successfully Deleted.');
          this.reloadCurrentRoute();
        }
        else{
          alert('something went wrong');
        }
      })
  }


  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
}
}



// WEBPACK FOOTER //
// ./src/app/admin/subscription-product/subscription-product.component.ts